import * as types from './mutation-types';
import { defaultOsSituationState } from './state';

export default {
  [types.RESET_OS_SITUATION](state) {
    Object.assign(state.osSituation, defaultOsSituationState());
  },
  [types.SET_SUMMARY_OS_SITUATIONS](state, payload) {
    state.summaryOsSituations = payload;
  },
  [types.SET_PAGINATION_OS_SITUATIONS](state, payload) {
    state.paginationOsSituations = payload;
  },
  [types.SET_DETAILED_OS_SITUATION](state, payload) {
    state.osSituation = payload;
  },
  [types.SET_OS_SITUATIONS_WARNINGS](state, payload) {
    state.osSituationsWarnings = payload;
  },
};
